import React from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { getUiInterface } from "../../../locales/translationUtils";
import getFilterLabels from "../../../types/filterLabels";

interface FilterProps {
  filters: Record<string, string>;
  onFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSearch: () => void;
}

const Filter: React.FC<FilterProps> = ({
  filters,
  onFilterChange,
  onSearch,
}) => {
  const filterLabels = getFilterLabels();
  return (
    <Form className="mb-3">
      <Row className="mb-3">
        {Object.entries(filters)
        .filter(([key]) => !["pageNum", "quantityPerPage"].includes(key))
        .map(([key, value]) => (
          <Col md={2} key={key}>
            <Form.Group controlId={`filter-${key}`} className="mt-2">
              <Form.Label>
                {filterLabels[key] ||
                  key.charAt(0).toUpperCase() + key.slice(1)}
              </Form.Label>
              <Form.Control
                type="text"
                placeholder={key}
                name={key}
                value={value}
                onChange={onFilterChange}
              />
            </Form.Group>
          </Col>
        ))}
      </Row>
      <Row>
        <Col md={4}>
          <Button variant="primary" onClick={onSearch}>
            {getUiInterface("search")}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default Filter;
